<template>
	<div class="message-toast">
		<div v-if="props.title" class="title">{{ props.title }}</div>
		<div class="message">{{ props.message }}</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title?: string;
	message: string;
}>();
</script>

<style scoped>
.message-toast {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	gap: 4px;
}

.title {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;

	color: #ffffff;
}

.message {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 300;
	font-size: 11px;
	line-height: 13px;

	color: rgba(255, 255, 255, 0.7);
}
</style>
